import { startOfTomorrow } from 'date-fns/startOfTomorrow';

import { getZonedDate } from '@eika-infrastruktur/date';

import type { RecurringPaymentAgreement } from '../../../../generated-types';
import { RecurringPaymentState } from './state';

export default (recurringPayment: RecurringPaymentAgreement): RecurringPaymentState => ({
    note: recurringPayment.text || '',
    ownText: recurringPayment.ownText,
    amount: recurringPayment.amount,
    showFromAccounts: false,
    showToAccounts: false,
    fromAccount: recurringPayment.fromAccountNumber,
    toAccount: { accountNumber: recurringPayment.toAccount },
    paymentInterval: recurringPayment.paymentInterval,
    firstPaymentDate: getZonedDate(recurringPayment.nextPaymentDate),
    firstBankingDate: getZonedDate(startOfTomorrow()),
    lastPaymentDate: recurringPayment.lastPaymentDate ? getZonedDate(recurringPayment.lastPaymentDate) : undefined,
});
